<template>
  <div>
    <sts-trailer :auto="car" @changed="changedElement" />
    <file-sts-trailer ref="trailerFiles" :auto="car" />
    <el-row :gutter="24">
      <el-col :span="24">
        <div v-if="!isMobile" style="text-align: right">
          <el-button style="margin-top: 12px" type="primary" @click="saved">
            Сохранить авто и прицеп
          </el-button>
        </div>

        <div v-if="isMobile">
          <el-button style="margin-top: 12px" type="success" @click="saved">
            Сохранить авто и прицеп
          </el-button>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { filesValidateMixinParentActions } from '@/mixins/filesValidateMixin'
import FileStsTrailer from '../Forms/FileStsTrailer'
import StsTrailer from '../Forms/StsTrailer'
import mixinForms from '../Mixins/forms'

export default {
  name: 'AddTrailer',
  components: { FileStsTrailer, StsTrailer },
  mixins: [mixinForms, filesValidateMixinParentActions],

  data() {
    return {
      validRules: {
        stsTrailer: {
          required: true,
          message: 'Введите номер СТС прицепа',
          trigger: 'blur',
        },
      },
      returnData: {
        stsTrailer: '',
        plateTrailer: '',
      },
      source_id: this.carId,
      source_model_id: 1,
    }
  },
  methods: {
    saved() {
      this.$emit('saved', this.returnData)
    },
  },
}
</script>
